<template>
  <div>
    <PageTitle
      title="Warehouses"
      :btnCreate="true"
      :createRoute="'Warehouse'"
      :createPopup="true"
      @onClickCreate="OpenModal()"
      :permission="'Ware House Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb*2" v-show="show">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['status', 'search']"
              v-model="filter"
              :columns="columns"
              :msgs="'Name'"
            ></TableFilters>

            <ImportExportMenu
              :permission="'Ware House Report'"
            ></ImportExportMenu>
          </v-row>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 card-content mt-2 pa-3">
        <AddWarehouse
          :visible="showScheduleForm"
          @close="AddWarehouse($event)"
          @afterSave="refreshData()"
        />

        <EditWarehouse
          :visible="EditScheduleForm"
          :warehouse="editwarehouse"
          @close="EditWarehouse($event)"
          @afterSave="refreshData()"
        />
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :items-per-page="paginationOptions.perPage"
          class="row-pointer"
          @click:row="$router.push(`warehouse/${$event.id}`)"
          :fixed-header="true"
          :headers="headers"
          :items="Warehouse"
          item-key="id"
          hide-default-footer
          style="
            font-weight: normal;
            font-family: 'Source Sans Pro', sans-serif;
          "
        >
          <template v-slot:no-data>
            <noData
              class="mt-16 container justify-center item-center"
              name="warehouse"
            />
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>

          <template v-slot:item.name="{ item }" :slot-scope="props">
            <div class="warehouse-dets tbl-data">
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ma-2"
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >mdi-information</v-icon
                  >
                </template>
                <span> {{ item.name ? item.name : '---------' }}</span>
              </v-tooltip>
              {{ item.name ? item.name : '---------' }}
            </div>
          </template>

          <template v-slot:item.sortform="{ item }" :slot-scope="props">
            <div class="tbl-data">
              {{ item.sortform ? item.sortform : '---------' }}
            </div>
          </template>

          <template v-slot:item.phone="{ item }" :slot-scope="props">
            <div class="tbl-data">
              {{ item.phone ? item.phone : '---------' }}
            </div>
          </template>

          <template v-slot:item.address="{ item }" :slot-scope="props">
            <div class="warehouse-dets tbl-data">
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ma-2"
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >mdi-information</v-icon
                  >
                </template>
                <span> {{ item.address }}</span>
              </v-tooltip>
              {{ item.address ? item.address : '---------' }}
            </div>
          </template>

          <template v-slot:item.description="{ item }" :slot-scope="props">
            <div class="warehouse-dets tbl-data">
              {{ item.description ? item.description : '---------' }}
            </div>
          </template>

          <!-- Status -->
          <template v-slot:item.status="{ item }" :slot-scope="props">
            <!-- <toggle-button
              v-if="editWarehouseId == item.id"
              :disabled="editWarehouseId != item.id"
              :value="item.is_active"
              :width="80"
              v-model="newbrand.is_active"
              :labels="{ checked: 'Active', unchecked: 'Archeived' }"
            ></toggle-button> -->

            <v-chip
              :x-small="true"
              class="ma-2"
              label
              style="font-weight: 800; font-variant-caps: all-small-caps"
              text-color="white"
              :color="getStatusColor(item.is_active)"
              dark
              >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
            >
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="warehouse"
              :item="item"
              viewPermission="Ware House Show"
              editPermission="Ware House Edit"
              softDeletePermission="Ware House Soft Delete"
              @refreshList="refreshData"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
            ></list-menu>
          </template>
          <template v-slot:footer>
            <pagination
              @paginationOptions="setPaginationOptions"
              url="ware-houses"
              :filterAction="true"
              @getPageNumber="setPagenumber"
              @response="receiveCategoryData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';

import pagination from '../../../../shared/components/pagination';
import confirmation from '../../../../shared/components/confirmation';
import { WarehouseModel, Warehouse } from '../../../../../models/Warehouse';
import AddWarehouse from './WarehouseCreate';
import EditWarehouse from './WarehouseEdit';
import { required, email, max } from 'vee-validate/dist/rules';
import _ from 'lodash';
import noData from '../../../../../components/shared/noItem';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { WareHouseEntityModel } from '../../../../../models/EntityModels/WareHouseEntityModel';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
export default {
  components: {
    pagination,
    ValidationProvider,
    EditWarehouse,
    ValidationObserver,
    AddWarehouse,
    TableFilters,
    noData,
  },
  data() {
    return {
      show: false,
      paginationOptions: {},
      isLoading: false,
      showScheduleForm: false,
      EditScheduleForm: false,
      editwarehouse: new Warehouse(),
      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: 'fat',
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: 'Active', value: 'active' },
        { text: 'Archived', value: 'archived' },
      ],
      columns: [
        {
          text: 'Name',
          value: 'name',
          show: true,
          align: 'left',
          disabled: false,
          width: '16.5%',
        },
        {
          text: 'Sortform',
          value: 'sortform',
          show: true,
          align: 'left',
          disabled: false,
          width: '16.5%',
        },
        {
          text: 'Phone',
          value: 'phone',
          show: true,
          disabled: false,
          width: '16.5%',
        },
        {
          text: 'Address',
          value: 'address',
          align: 'left',
          show: true,
          disabled: false,
          width: '16.5%',
        },
        {
          text: 'Description',
          value: 'description',
          show: true,
          align: 'left',
          disabled: false,
          width: '16.5%',
        },
        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
          align: 'center',
          width: '16.5%',
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          align: 'center',
          width: '16.5%',
          sortable: false,
        },
      ],
      Warehouse: [],
      newbrand: { name: '', id: '', is_active: '' },
      filter: {
        name: '',
        search: '',
        status: '',
      },
    };
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    // this.GetWarehouses();
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    OpenModal() {
      this.showScheduleForm = true;
    },
    receiveCategoryData(data) {
      this.Warehouse = data;
    },

    EditModal(data) {
      this.EditScheduleForm = true;
      this.GetWareHouseSingle(data.id);
    },
    AddWarehouse($event) {
      this.showScheduleForm = false;
    },
    EditWarehouse($event) {
      this.EditScheduleForm = false;
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    openConfirmation(warehouse) {
      confirmation.dialog = true;
      this.$confirm(
        'Do you want to ' +
          (warehouse.is_active ? 'Archive  ' : 'Activate  ') +
          warehouse.name +
          '?',
      ).then((res) => {
        if (res) {
          this.GetArchiveMsgs(warehouse);
        }
      });
    },
    GetArchiveMsgs(warehouse) {
      this.$store
        .dispatch('warehouse/ArchiveOrActive', warehouse.id)
        .then((res) => {
          warehouse.is_active = !warehouse.is_active;
          this.refreshData();
          const msg = warehouse.is_active ? 'activated' : 'archived';
          this.$toast.success('Successfully  ' + msg);
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;

          this.$toast.error('Archeive  failed');
        });
    },
    GetWareHouseSingle(id) {
      this.$store
        .dispatch(`warehouse/GetWarehouseSingleId`, id)
        .then((res) => {
          this.editwarehouse = res.data;
          this.refreshData();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.tbl-data {
  /* font-weight: bold; */
}
.warehouse-dets {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
